// Mock data for Rabbit Box Ads clone

export const ASSET_BASE = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_0d8e15c3-15a9-4ede-8409-41e87565da06/artifacts/assets/images';

export const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Verticals', href: '#verticals' },
  { label: 'Contact', href: '#contact' },
];

export const SERVICES = [
  {
    key: 'branding',
    title: 'Strategic Branding',
    desc: 'Crafting a solid brand strategy, defining target audiences, and ensuring a distinctive market position.',
    icon: 'Target',
  },
  {
    key: 'design',
    title: 'Creative Design',
    desc: 'Developing visually appealing assets such as logos, posters, and promotional materials that resonate with the brand or movie.',
    icon: 'PenTool',
  },
  {
    key: 'digital',
    title: 'Digital Marketing Mastery',
    desc: 'Leveraging online platforms through social media campaigns, email marketing, content creation, and search engine optimization.',
    icon: 'Globe',
  },
  {
    key: 'media',
    title: 'Media Planning & Buying',
    desc: 'Strategizing and securing advertising space across diverse channels, from traditional media to online platforms.',
    icon: 'Megaphone',
  },
  {
    key: 'events',
    title: 'Eventful Experiences',
    desc: 'Planning and executing engaging events, premieres, and experiential marketing campaigns to connect directly with the audience.',
    icon: 'Sparkles',
  },
  {
    key: 'analytics',
    title: 'Performance Analytics',
    desc: 'Monitoring and analyzing campaign performance, utilizing data-driven insights to enhance strategies and maximize impact.',
    icon: 'LineChart',
  },
];

export const PRODUCTION_CLIENTS = [
  { name: 'Wayfarer Films', tag: 'Kochi' },
  { name: 'Aashirvad', tag: 'Kerala' },
  { name: 'Sree Gokulam', tag: 'India' },
  { name: 'E4 Entertainment', tag: 'Cinema' },
  { name: 'Century Films', tag: 'Chennai' },
  { name: 'Weekend Blockbusters', tag: 'Cinema' },
  { name: 'Mini Studio', tag: 'Kerala' },
  { name: 'Magic Frames', tag: 'India' },
  { name: 'Cheers Entertainments', tag: 'Kochi' },
  { name: 'Anto Joseph Films', tag: 'Kerala' },
  { name: 'Prithviraj Productions', tag: 'India' },
  { name: 'Sunny Wayne Films', tag: 'Cinema' },
];

export const BRAND_CLIENTS = [
  { name: 'Medimix', tag: 'Wellness' },
  { name: 'Melam', tag: 'Foods' },
  { name: 'Triangle', tag: 'Property' },
  { name: 'UHC', tag: 'Health' },
  { name: 'Jaso', tag: 'Retail' },
  { name: 'PLP', tag: 'Lifestyle' },
  { name: 'Kathak', tag: 'Culture' },
  { name: 'EA', tag: 'Events' },
  { name: 'Babeye', tag: 'Baby Care' },
  { name: 'Yathra', tag: 'Travel' },
  { name: 'AV Premiere', tag: 'Cinema' },
  { name: 'Zoey', tag: 'Fashion' },
];

export const SHOWCASE = [
  'https://images.unsplash.com/photo-1590179068383-b9c69aacebd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxmaWxtJTIwcG9zdGVyfGVufDB8fHx8MTc5MDY5NjMxNnww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1536766768598-e09213fdcf22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA2OTYzMTV8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1780764818559-1dd2205ea2c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxmaWxtJTIwcG9zdGVyfGVufDB8fHx8MTc5MDY5NjMxNnww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1553614186-d23d17be2ad3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxkcmFtYXRpYyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc5MDY5NjMyMXww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1508179522353-11ba468c4a1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxuZW9uJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwNjk2MzI3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1536759078151-61c8b6f156a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjb2xvcmZ1bCUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY5NjMyMXww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTA2OTYzMTV8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1499155286265-79a9dc9c6380?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxuZW9uJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwNjk2MzI3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1615276884890-2f2ffdab7b43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxuZW9uJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwNjk2MzI3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1741036379058-cca704d04101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDY5NjMyMXww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1644353224392-7e532d7b8f4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxuZW9uJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwNjk2MzI3fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwZWRpdG9yaWFsfGVufDB8fHx8MTc5MDY5NjMyN3ww&ixlib=rb-4.1.0&q=85',
];

export const PROJECT_TITLES = [
  'Christopher — Feature Launch',
  'Monsoon Edit — Brand Film',
  'Vallaty — Theatrical Campaign',
  'Iraivan — Poster Series',
  'RDX — Digital Rollout',
  'Aavesham — Social Blitz',
  'JP — Print & OOH',
  'AK-61 — Motion Posters',
  'AOVV — Multi-city Premiere',
  'Yathra — Travel Campaign',
  'Medimix — Wellness Series',
  'Kathak — Culture Reels',
];

export const WHY_US = [
  {
    title: 'Expertise in Entertainment and Branding',
    desc: 'With years of experience in the entertainment and branding sectors, our team possesses the unique skills and knowledge necessary to navigate these dynamic industries. We understand what makes audiences tick and how to leverage that understanding for your success.',
    icon: 'Award',
  },
  {
    title: 'Creative Excellence',
    desc: 'Our creative team is at the forefront of design, storytelling, and digital innovation. From eye-catching visuals to compelling narratives, we ensure that every campaign is not just seen but remembered and cherished.',
    icon: 'Wand2',
  },
  {
    title: 'Data-Driven Strategies',
    desc: 'At Rabbit Box Ads, we combine creativity with analytics. By utilizing the latest in market research and data analysis, we ensure that our strategies are not just creative but also effective in reaching your target audience and achieving your goals.',
    icon: 'BarChart3',
  },
  {
    title: 'Personalized Approach',
    desc: 'We believe that no two projects are the same. That\u2019s why we adopt a personalized approach to each campaign, ensuring that your unique story and objectives are at the heart of everything we do.',
    icon: 'Heart',
  },
];

export const VERTICALS = [
  { name: 'Hue', tagline: 'Design & Brand Identity', color: '#e07a3c' },
  { name: 'Soul', tagline: 'Storytelling & Content', color: '#c94b4b' },
  { name: 'Loop', tagline: 'Digital & Performance', color: '#3c6e91' },
];

export const CONTACT = {
  phone: '+91 81370 55567',
  phoneRaw: '918137055567',
  email: 'info@rabbitboxads.com',
  address: '63B, Eastern Villas, TV Centre, Kakkanad',
  city: 'Ernakulam, Kerala, India - 682037',
};

export const YOUTUBE_VIDEO_ID = '5o-88RnobYE';
export const HERO_IMAGE = `${ASSET_BASE}/web-v2-1356x706.jpg`;
